module.exports = __webpack_public_path__ + "Icono_PaqueteBudles_126px.png";